import {
  FinanceHubSidebarNavItem,
  useFinanceHubSidebarNavItemsLoader,
} from '@finance-hub/containers/sidebar/blocs/loaders/use-finance-hub-sidebar-nav-items-loader';
import { FinanceHubTabParams } from '@/navigators/types';
import { navigateToFinanceHubRoute } from '@finance-hub/finance-hub-route-config';
import { NavigationProp, useNavigation } from '@react-navigation/native';
import { SidenavItem } from '@/domain/navigation/types';
import { useCallback, useMemo } from 'react';

interface UseFinanceHubSidebarNavResult {
  loading: boolean;
  navItems: SidenavItem[];
}

export const useFinanceHubSidebarNav = (): UseFinanceHubSidebarNavResult => {
  const { navItems: loaderItems, loading } =
    useFinanceHubSidebarNavItemsLoader();
  const navigation = useNavigation<NavigationProp<FinanceHubTabParams>>();

  const handleNavItemPress = useCallback(
    (item: FinanceHubSidebarNavItem) => {
      navigateToFinanceHubRoute(navigation, item.route);
    },
    [navigation],
  );

  const navItems = useMemo<SidenavItem[]>(
    () =>
      loaderItems.map((item) => ({
        active: item.isActive,
        icon: item.icon,
        iconUrl: item.iconUrl,
        label: item.label,
        onPress: () => handleNavItemPress(item),
      })),
    [loaderItems, handleNavItemPress],
  );

  return { loading, navItems };
};
